import React, { useMemo } from "react";
import _ from "lodash";
import { Chip, makeStyles } from "@material-ui/core";
import { Map } from "immutable";

const DELIMITER = "::";

interface Props {
    activeFiltersValues: Map<string, any>;
    onDelete: (v: Map<string, any>) => void;
}

export function SelectedFiltersOptions({ activeFiltersValues, onDelete }: Props) {
    const options = useMemo(
        () =>
            _.flatMap(activeFiltersValues?.toJS(), (values, key) =>
                _.isArray(values) // skip some filters like __inventory
                    ? _.map(values, (value: string) => ({
                          key: value,
                          label: _.split(value, DELIMITER).join(":"), // ex., category:subcategory, color, but not category::subcategory
                          onDelete: () => {
                              const filter = activeFiltersValues.get(key).filter((x) => x !== value);
                              onDelete(
                                  filter.size ? activeFiltersValues.set(key, filter) : activeFiltersValues.remove(key),
                              );
                          },
                      }))
                    : [],
            ),
        [activeFiltersValues, onDelete],
    );
    const classes = useStyles();
    return (
        <div className={classes.container}>
            {options.map(({ key, label, onDelete }) => (
                <Chip
                    key={key}
                    label={label}
                    onDelete={onDelete}
                    classes={{ root: classes.chip, label: classes.label }}
                />
            ))}
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        marginBottom: 10,
    },
    chip: {
        overflow: "hidden", // ellipsis on large values
    },
    label: {
        color: "#2d2d2d",
        fontSize: 14,
        fontFamily: "Lato, sans-serif",
    },
});
